<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item><router-link to="/vehicle">Vehicle Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item @click="goBack()">Detail Vehicle</b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6" class="mt-3 text-right">
                <!-- <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToExcel" variant="info" class="btn-download float-right"><font-awesome-icon icon="download"/></b-button> -->
                <!-- <b-button v-if="model.status !== 'Paid'" v-b-tooltip.hover.top title="Pay" variant="primary" class="mr-1 float-right" @click="showModalTypePay()"><font-awesome-icon icon="donate"></font-awesome-icon></b-button> -->
            </b-col>
        </b-row>
        <div class="border-bottom mb-3" />
        <template v-if="isLoading">
            <div class="d-flex justify-content-center mb-5 mt-5 pt-5 pb-5">
                <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Loading..."></b-spinner>
            </div>
        </template>
        <template v-else>
            <b-form class="mt-2">
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="4"><label class="labels">Brand</label></b-col>
                            <b-col md="8"><p>{{ model.vehicle !== null ? model.vehicle.merk : '-' }}</p></b-col>
                            <!-- <p class="label-detail">{{ model.vehicle !== null ? model.vehicle.merk : '-' }}</p> -->
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Model</label></b-col>
                            <b-col md="8"><p>{{ model.vehicle !== null ? model.vehicle.model : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Plate</label></b-col>
                            <b-col md="8"><p>{{ model.vehicle !== null ? model.vehicle.plate : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">road tax no.</label></b-col>
                            <b-col md="8"><p>{{ model.billNumber !== null ? model.billNumber : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">type</label></b-col>
                            <b-col md="8"><p>{{ model.type !== null ? model.type : '-' }}</p></b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                            <b-col md="4"><label class="labels">issued by</label></b-col>
                            <b-col md="8"><p>{{ model.issuedBy !== null ? model.issuedBy : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">issued date</label></b-col>
                            <b-col md="8"><p>{{ model.issuedDate !== null ? getDateTime(model.issuedDate) : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Expired Date</label></b-col>
                            <b-col md="8"><p>{{ model.dueDate !== null ? model.dueDate : '-' }}</p></b-col>
                        </b-row>
                        <!-- <b-row>
                            <b-col md="4"><label class="labels">paid Date</label></b-col>
                            <b-col md="8"><p>{{ model.paidDate !== null ? model.paidDate : '-' }}</p></b-col>
                        </b-row> -->
                        <b-row>
                            <b-col md="4"><label class="labels">amount</label></b-col>
                            <b-col md="8"><p>{{ dataAccount.account.currency }} {{ model.amount !== null ? formatPrice(model.amount) : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">note</label></b-col>
                            <b-col md="8"><p class="text-justify">{{ model.note !== null ? model.note : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Status</label></b-col>
                            <b-col md="8"><p><b-badge :variant="getStatusColor(model.status)">{{getStatusName(model.status)}}</b-badge></p></b-col>
                        </b-row>
                        <b-row v-if="model.statusDate !== ''">
                            <b-col md="4">
                                <label class="labels">{{model.statusTextDate}}</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.statusDate }}</p>
                            </b-col>
                        </b-row>
                        <b-row v-if="model.statusValue !== ''">
                            <b-col md="4">
                                <label class="labels">{{model.statusText}}</label>
                            </b-col>
                            <b-col md="8">
                                <p>{{ model.statusValue }}</p>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mt-3 mb-2">
                        <h5>Photo</h5>
                    </b-col>
                    <b-col md="12">
                        <b-row v-if="model.vehiclePhotoList.length === 0">
                            <b-col md="3 py-1">
                              <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="60"/><br><br><i>No Photo Submitted</i></p>
                            </b-col>
                        </b-row>
                        <viewer :images="model.vehiclePhotoList" v-else>
                            <b-row>
                                <b-col md="3" v-for="(src, index) in model.vehiclePhotoList" :key="index">
                                    <b-img :src="src" class="img-responsive mt-2 px-2" width="225" height="175"/>
                                </b-col>
                            </b-row>
                        </viewer>
                    </b-col>
                </b-row>
            </b-form>
            <b-button class="mt-5" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
            <b-button v-if="model.status === 'New'" class="mt-5 float-right" :to="'/vehicle/road-tax-detail/' + $route.params.uuid + '/edit'" variant="warning"><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button>
        </template>
    </b-card>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'vehicle-show',
        data () {
            return {
                isLoading: false,
                activeTab: 'Road Tax',
                dataAccount: this.$store.getters['account/accountData'],
                apiUrl: {
                    vehicleBillInfo: window.AppConfig.apiUrl + 'vehicle-bill-info',
                },
                model: {
                    options: {
                        value: null
                    },
                    type: null,
                    vehicle: null,
                    billNumber: null,
                    paidDate: null,
                    dueDate: null,
                    amount: null,
                    vehicleBillPhoto: null,
                    note: null,
                    merk: '',
                    model: '',
                    year: '',
                    plate: '',
                    photo1: null,
                    photo2: null,
                    photo3: null,
                    roadtax: '',
                    note: '',
                    issuedBy: null,
                    issuedDate: null,
                    status: null,
                    statusValue: '',
                    statusDate: '',
                    vehiclePhotoList: []
                },
                data: {
                    photo1File: null,
                    photo2File: null,
                    photo3File: null
                },
                modelValidations: {
                    photo1: {
                        required: false
                    },
                    photo2: {
                        required: false
                    },
                    photo3: {
                        required: false
                    }
                },
                vehicleRequestList: []
            }
        },
        mounted () {
            this.getDetail()
        },
        methods: {
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.vehicleBillInfo + '/' + this.$route.params.uuid)
                .then(response => {
                  this.model.type = response.data.type !== null ? response.data.type : '-'
                    this.model.vehicle = response.data.vehicle !== null ? response.data.vehicle : null
                    this.model.billNumber = response.data.billNumber !== null && response.data.billNumber !== 'null' && response.data.billNumber !== '' && response.data.billNumber !== undefined ? response.data.billNumber : '-'
                    this.model.options = response.data.options !== null ? response.data.options[0].value : null
                    this.model.dueDate = response.data.dueDate !== null ? this.$moment(response.data.dueDate).format('YYYY-MM-DD') : '-'
                    this.model.paidDate = response.data.paidDate !== null ? this.getDateTime(response.data.paidDate) : '-'
                    this.model.amount = response.data.amount !== null || response.data.amount !== 'null' ? response.data.amount : '-'
                    this.model.vehicleBillPhoto = response.data.vehicleBillPhoto !== null ? response.data.vehicleBillPhoto[0].url : null
                    if (this.model.vehicleBillPhoto !== null) {
                    this.model.vehiclePhotoList = []
                        response.data.vehicleBillPhoto.forEach(data => {
                            this.model.vehiclePhotoList.push(data.url)
                        })
                    }
                    this.model.issuedBy = response.data.issuedBy !== null ? response.data.issuedBy : '-'
                    this.model.status = response.data.status !== null ? response.data.status : '-'
                    this.model.note = response.data.note !== null && response.data.note !== 'null' && response.data.note !== '' && response.data.note !== undefined ? response.data.note : '-'
                    this.model.issuedDate = this.$moment(response.data.createdAt).format('YYYY-MM-DD hh:mm a')
                    this.model.updatedAt = response.data.updatedAt
                    this.model.uuid = response.data.uuid
                    this.isLoading = false
                    if (response.data.paidBy !== null || response.data.paidDate !== null) {
                        this.model.statusText = 'Paid By'
                        this.model.statusTextDate = 'Paid Date'
                        this.model.statusValue = response.data.paidBy !== null ? response.data.paidBy : '-'
                        this.model.statusDate = response.data.paidDate !== null ? this.$moment(response.data.paidDate).format('YYYY-MM-DD') : '-'
                    }
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                    // this.$router.push('/notfound')
                })
            },
            showModalTypePay() {
                this.$swal({
                title: 'Are you sure?',
                text: 'You will make a pay transaction on this vehicle!',
                icon: "info",
                buttons: true,
                dangerMode: false,
                buttonsStyling: false,
                }).then(result => {
                if (result) {
                    let formData = new FormData()
                    formData.append('uuid', this.model.uuid)
                    formData.append('billNumber', this.model.billNumber)
                    formData.append('amount', this.model.amount)
                    formData.append('note', this.model.note)
                    this.$http.post(window.AppConfig.apiUrl + 'vehicle-paid-bill', formData)
                    .then((response) => {
                    this.$swal.close()
                    this.getDetail()
                    this.$store.dispatch('notification/success', 'Road Tax data has been paid')
                    })
                    .catch(error => {
                    this.$store.dispatch('notification/error', error)
                    });
                }
                })
            },
            doExportToExcel () {
              let url = window.AppConfig.apiUrl + '' + '?token=' + this.$store.getters['account/tokens'].access_token + '&requested_by=' + this.$route.params.uuid
            //   let url = window.AppConfig.apiUrl + '' + '?token=' + this.$store.getters['account/tokens'].access_token + '&requested_by=' + this.$route.params.uuid + '&status=' + this.$route.query.status + '&start_date=' + this.$route.query.start_date + '&end_date=' + this.$route.query.end_date
            //   console.log(url)
              window.open(url)
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace(',', '.')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD')
                } else {
                    return '-'
                }
            },
            getStatusColor (val) {
                switch (val) {
                case 'New':
                return 'secondary'
                // eslint-disable-next-line no-unreachable
                break
                case 'Paid':
                return 'primary'
                // eslint-disable-next-line no-unreachable
                break
                }
            },
            getStatusName (val) {
                switch (val) {
                case 'New':
                    return 'Waiting For Payment'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Paid':
                    return 'Paid'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            },
            goBack () {
                window.goBack(this)
            }
        }
    }
</script>